export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderSuggestions@3x.png";